import React from "react";
import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import FormDropDown from "../../../common/layout/form/FormDropDown";
import { postalCodes } from "../../data/postalCodes";
import NewFormBtns from "../../../common/layout/form/NewFormBtns";
import { validationSchemaPrice } from "../../actions/validationSchema";
import { dropDownS } from "../../styles/dropDown.styles";
import Price from "./Price";

export interface PriceFormProps {
  handleSubmit: any;
  orderTypesItems: Array<any>;
  initValues: any;
  cancelForm: any;
}

const PriceForm: React.FC<PriceFormProps> = ({
  handleSubmit,
  orderTypesItems,
  initValues,
  cancelForm,
}) => {
  const { t } = useTranslation("admin");
  return (
    <Formik
      initialValues={initValues}
      enableReinitialize={true}
      onSubmit={handleSubmit}
      validationSchema={validationSchemaPrice}
      validateOnChange={false}
      validateOnBlur={false}
    >
      {({ handleSubmit, values }) => (
        <form onSubmit={handleSubmit}>
          <div className={dropDownS}>
            <FormDropDown
              headerText={t("nav.panelType") as string}
              name="orderTypeItemId"
              options={orderTypesItems}
            />
          </div>
          <div>
          {postalCodes.map((code: string) => (
            <Price
              key={code}
              name={code}
              label={t("nav.priceForCode", { code }) as string}
              required={false}
            />
          ))}
          </div>

          <NewFormBtns
            submitBtnText={!Object.keys(initValues).length ? t("nav.add") as string : t("nav.edit") as string}
            cancelForm={cancelForm}
            positionAbsolute={true}
          />
        </form>
      )}
    </Formik>
  );
};

export default PriceForm;
